
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { stockSearch } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
key: "",
list: [],
history: []
}
},
computed:{
...mapState(['token'])
},
created(){
if(!!window.localStorage.getItem('history')){
this.history =JSON.parse(window.localStorage.getItem('history'))
}
this.SETTOKEN()
},
methods:{
...mapMutations(['SETTOKEN']),
search(){
var that = this
stockSearch({token: this.token,key: this.key}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.list = res.data
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
console.log("error")
})
},
delHistory(){
this.history = []
window.localStorage.setItem('history', '')

},
goInfo(item){
this.history.push({pin: item.pin,flag: item.flag})
window.localStorage.setItem('history', JSON.stringify(this.history))
this.$router.push(`/pages/info?name=${item.pin}&trade_type=3&code=${item.pin}&nation=${item.flag}`)
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{
key: {
handler(curVal, oldVal) {
if(curVal!=oldVal){
this.search()
}


},
deep: true
},

}
}



// WEBPACK FOOTER //
// ./src/pages/search.vue